import React from "react";
import "./AuroraBackground.css";

const AuroraBackground = ({ theme }) => {
  React.useEffect(() => {
    if (theme === "dark") {
      document.documentElement.style.setProperty("--star-color-light", "#fff"); // Bright stars for light theme
    } else {
      document.documentElement.style.setProperty("--star-color-light", "#000"); // Dim stars for dark theme
    }
  }, [theme]);

  return (
    <div className="fixed top-0 left-0 w-full h-full">
      <div id="stars"></div>
      <div id="stars2"></div>
      <div id="stars3"></div>
    </div>
  );
};

export default AuroraBackground;
